import React from 'react';
import { Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native';
import { AdminColors } from '../../../Admin/constants/adminColors';
import FontFamily from '../../../../constants/fonts';
import { ConfigTabId } from '../configTypes';
import { CONFIG_TABS } from '../constants';

interface ConfigTabBarProps {
  activeTab: ConfigTabId;
  onChange: (tab: ConfigTabId) => void;
}

/** Tab bar (.tabs-nav / .tab): 2px rule, 14px labels, active tab bold blue with a 2px underline. */
const ConfigTabBar: React.FC<ConfigTabBarProps> = ({ activeTab, onChange }) => (
  <ScrollView
    horizontal
    showsHorizontalScrollIndicator={false}
    style={styles.tabBar}
    contentContainerStyle={styles.tabBarContent}
  >
    {CONFIG_TABS.map((tab) => {
      const active = activeTab === tab.key;
      return (
        <TouchableOpacity
          key={tab.key}
          style={[styles.tab, active && styles.tabActive]}
          onPress={() => onChange(tab.key)}
          activeOpacity={0.7}
          accessibilityRole="tab"
          accessibilityState={{ selected: active }}
        >
          <Text style={[styles.tabLabel, active && styles.tabLabelActive]}>{tab.label}</Text>
        </TouchableOpacity>
      );
    })}
  </ScrollView>
);

const styles = StyleSheet.create({
  tabBar: {
    borderBottomWidth: 2,
    borderBottomColor: AdminColors.borderTable,
    flexGrow: 0,
    minHeight: 48,
  },
  tabBarContent: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingTop: 8,
    paddingHorizontal: 8,
    paddingBottom: 1,
  },
  tab: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderBottomWidth: 2,
    borderBottomColor: 'transparent',
    marginBottom: -2,
  },
  tabActive: {
    borderBottomColor: AdminColors.blue700,
  },
  tabLabel: {
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '500',
    color: AdminColors.textSecondary,
    fontFamily: FontFamily.medium,
  },
  tabLabelActive: {
    color: AdminColors.blue700,
    fontWeight: '700',
    fontFamily: FontFamily.bold,
  },
});

export default ConfigTabBar;
